import type { ReactNode } from 'react'
import { Box, Card, Header, Text } from '@truepill/react-capsule'
import { LaunchDarkly } from '@truepill/tpos-types'
import { ReactComponent as WarningIcon } from '../../assets/icons/warning.svg'
import tposLogo from '../../assets/logo/tpos.png'
import { useFlag } from '../../providers/LaunchDarklyProvider'
import { SiteStatus } from '../../types'

interface Props {
  children: ReactNode
}

export const DownTimePage = ({ children }: Props): JSX.Element => {
  const siteStatusFf = useFlag(LaunchDarkly.FeatureFlags.SITE_PERFORMANCE_STATUS) as SiteStatus

  if (siteStatusFf === SiteStatus.DOWN) {
    return (
      <Box
        css={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box css={{ flex: 1, overflowY: 'auto' }}>
          <Box css={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
            <img src={tposLogo} alt="TPOS Logo" style={{ width: '150px', height: 'auto' }} />
          </Box>
          <Card
            css={{
              padding: '24px',
              width: '100%',
              maxWidth: '80%',
              margin: '80px auto 120px',
              textAlign: 'center',
            }}
          >
            <Box css={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
              <WarningIcon width="70" height="70" fill="#FFB74D" />
            </Box>
            <Header variant="4xl" css={{ textAlign: 'center', marginBottom: '16px' }}>
              System is temporarily down!
            </Header>
            <Text css={{ textAlign: 'center' }}>
              Our system is undergoing some maintenance or facing an issue. We'll be back up soon. Thanks for your
              patience!
            </Text>
          </Card>
        </Box>
      </Box>
    )
  }

  if (siteStatusFf === SiteStatus.DEGRADED) {
    return (
      <Box css={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Box
          css={{
            backgroundColor: '#FFF3CD',
            borderBottom: '1px solid #FFEAA7',
            padding: '12px',
            textAlign: 'center',
            flexShrink: 0,
          }}
        >
          <Box css={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <WarningIcon width="20" height="20" fill="#856404" />
            <Text css={{ color: '#856404', fontWeight: 'bold' }}>
              System is experiencing degraded performance. Some features may be slower than usual.
            </Text>
          </Box>
        </Box>
        <Box css={{ flex: 1, overflow: 'hidden' }}>{children}</Box>
      </Box>
    )
  }

  return <>{children}</>
}
